import { render } from "./PasFormsSetup.vue?vue&type=template&id=323f9f5c&scoped=true"
import script from "./PasFormsSetup.vue?vue&type=script&lang=js"
export * from "./PasFormsSetup.vue?vue&type=script&lang=js"

import "./PasFormsSetup.vue?vue&type=style&index=0&id=323f9f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323f9f5c"]])

export default __exports__